import { render, staticRenderFns } from "./_menu-item.vue?vue&type=template&id=f0cb8f70&"
import script from "./_menu-item.vue?vue&type=script&lang=js&"
export * from "./_menu-item.vue?vue&type=script&lang=js&"
import style0 from "./_menu-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports